import React, { useState } from 'react';
import { Button } from './Button';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon, ChevronUpIcon, ArrowLeftIcon, ArrowRightIcon } from 'lucide-react';
import { TransformationShowcase } from './TransformationShowcase';
export const MyStorySection: React.FC = () => {
  const [currentImage, setCurrentImage] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);
  const scrollToTrainingPlans = () => {
    const element = document.getElementById('plan-cards');
    if (element) {
      element.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });
    }
  };
  const images = [{
    src: 'https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/vwb5egz7newgdqpuo6r6qu/4a086d28-6024-43ad-b7cb-63b8ce93da6c/IMG_3583.jpg',
    caption: 'Po 6 měsících cvičení s užíváním superpotravin'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/xie2D3VKsTzsabZyotXKJX/Ondra-03.jpg',
    caption: 'Po 3 letech cvičení s užíváním superpotravin'
  }];
  const nextImage = () => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setCurrentImage(prev => (prev + 1) % images.length);
    setTimeout(() => {
      setIsTransitioning(false);
    }, 1000);
  };
  const myTransformationImages = [{
    src: 'https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/vwb5egz7newgdqpuo6r6qu/4a086d28-6024-43ad-b7cb-63b8ce93da6c/IMG_3581.jpg',
    caption: 'Tady jsem začínal se cvičením'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/eFPgFZwmTXDQNwwhGwZpcQ/Ondra-36_28229.jpg',
    caption: '3 roky cvičení společně s užíváním superpotravin'
  }];
  const dadTransformationImages = [{
    src: 'https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/vwb5egz7newgdqpuo6r6qu/4a086d28-6024-43ad-b7cb-63b8ce93da6c/IMG_3580.jpg',
    caption: 'Taťka - půl roku před užíváním superpotravin'
  }, {
    src: 'https://cdn.magicpatterns.com/uploads/vRZcXaraTVVAVkUDva87Pb/IMG_3579.jpg',
    caption: 'Taťka - po roce a půl užívání superpotravin'
  }];
  return <section className="section section-gradient-dark relative py-20" id="my-story" data-id="element-695">
      <div className="container mx-auto px-4 section-content" data-id="element-696">
        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} viewport={{
        once: true
      }} className="text-5xl md:text-6xl text-3xl font-black mb-12 text-center section-header-accent" data-id="element-697">
          MŮJ PŘÍBĚH
        </motion.h2>
        <div className="flex flex-col lg:flex-row gap-12 items-center" data-id="element-698">
          <div className="lg:w-1/2" data-id="element-699">
            <motion.h3 initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 0.6
          }} viewport={{
            once: true
          }} className="text-2xl md:text-3xl text-xl font-bold mb-6 md:mb-6 mb-3" data-id="element-700">
              Můj příběh. Reálné výsledky. Žádné zkratky.
            </motion.h3>
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} transition={{
            duration: 0.6,
            delay: 0.1
          }} viewport={{
            once: true
          }} className="text-lg md:text-lg text-sm space-y-4 md:space-y-4 space-y-2" data-id="element-701">
              <p data-id="element-702">
                Za tímhle projektem stojí roky konzistence, učení se z vlastním
                chyb a hlavně osobní zkušeností. Moje cesta nebyla snadná –
                prošel jsem si obdobím, kdy jsem nevěděl, jak dál. Ale právě
                tehdy jsem se rozhodl, že takhle to dál nejde.
              </p>
              <p data-id="element-703">
                Bylo to období, ve kterém jsem si myslel, že už není cesty ven,
                ale stejně jsem vzal kuráž a snažil se změnit můj život k
                lepšímu, tak abych si začal vážit a užívat každou chvíli kterou
                můžu na tomhle světě strávit. Objevil jsem sílu superpotravin,
                naučil se správně cvičit a překvapil sám sebe, kam až se můžu
                dostat za tak krátkou dobu, Níže se mužete podívat jak jsem
                vypadal po půl roce cvičení (fotka kde jsem na pláži).
              </p>
              <p data-id="element-704">
                Může to znít až moc kýčovitě, že nějaké "superpotraviny" dokážou
                člověka natolik změnit, a to přesně jsem si na začátku říkal
                takél. Ale po nějaké době konzistentího užívání superpotravin,
                mě to vážně překvapilo, přesněji to jak se cítím, jaké mám
                myšlenky, jak se mi tráví jídlo a mnoho dalších věcí. Právě
                tahla zkušenost mě utvrdila v tom, že chci, aby se
                superpotraviny dostaly k co nejvíce lidem. Po půl roce užívání
                jsem věděl, že tohle může změnit život komukoliv – stejně jako
                mně. Beru je už tři a půl roku a výsledky vidím dodnes. Stejně
                tak na svém tátovi.
              </p>
              <p data-id="element-705">
                Proměna mého táty bije do očí každému, kdo ho zná – někteří ho
                po změně ani nepoznali. A přitom necvičí tak aktivně jako já.
                Ráno si zajede na kole, jde se projít, občas zaposiluje… a i tak
                je jeho proměna obrovská. Když jsem viděl, co dokázaly "jen"
                superpotraviny, začal jsem přemýšlet, co všechno by mohlo
                vzniknout, kdyby se spojily s promyšleným tréninkem.
              </p>
              <p data-id="element-706">
                A právě tady to je! Vytvořil jsem plán postavený na studiích s
                reálnými výsledky tisíců lidí, doplněný o moje vlastní
                zkušenosti. Spojení kvalitního tréninku, superpotravin a doplňků
                stravy dokáže změnit ne jeden život, ale stovky, možná tisíce.
              </p>
              <p data-id="element-707">
                Tahla stránka je nástroj pro každého, kdo se rozhodne udělat
                krok k lepšímu já. Chci ti dát do rukou stejné nástroje, které
                změnily život nám… a můžou změnit i ten tvůj.
              </p>
              <p data-id="element-708">
                Věřím, že nic není náhoda. Stejně tak věřím, že jsi na těchto
                stránkách z určitého důvodu. Možná právě teď čteš tyto řádky,
                protože je čas, abych ti pomohl nasměrovat tvou cestu. Neber to
                na lehkou váhu – tohle může být ten moment, na který už dlouho
                čekáš. Moment, kdy se všechno změní.
              </p>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.4
          }} viewport={{
            once: true
          }} className="mt-8" data-id="element-709">
              <Button variant="primary" size="lg" onClick={scrollToTrainingPlans} className="luxury-button text-base md:text-xl text-base font-bold" data-id="element-710">
                CHCI ZAČÍT TAKY
              </Button>
            </motion.div>
          </div>
          <div className="lg:w-1/2" data-id="element-711">
            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.8
          }} viewport={{
            once: true
          }} className="relative hidden md:block" data-id="element-712">
              <div className="flex flex-col space-y-4 rounded-xl overflow-hidden shadow-2xl" data-id="element-713">
                <div className="relative h-[650px] md:h-[650px] h-[450px]" data-id="element-714">
                  <AnimatePresence mode="wait" data-id="element-715">
                    {images.map((image, index) => <motion.div key={index} initial={{
                    opacity: 0
                  }} animate={{
                    opacity: index === currentImage ? 1 : 0
                  }} exit={{
                    opacity: 0
                  }} transition={{
                    duration: 1
                  }} className="absolute inset-0" style={{
                    display: index === currentImage || isTransitioning ? 'block' : 'none'
                  }} data-id="element-716">
                        <img src={image.src} alt="Má transformace" className="w-full h-full object-cover rounded-xl" data-id="element-717" />
                        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black to-transparent p-6 md:p-6 p-4" data-id="element-718">
                          <p className="text-white text-lg md:text-lg text-sm font-medium" data-id="element-719">
                            {image.caption}
                          </p>
                        </div>
                      </motion.div>)}
                  </AnimatePresence>
                  <button onClick={nextImage} disabled={isTransitioning} className="absolute top-1/2 right-4 transform -translate-y-1/2 bg-black/70 backdrop-blur-sm rounded-full p-3 hover:bg-green-600/80 transition-colors z-10 shadow-lg border border-green-500/30 group" data-id="element-720">
                    <motion.div animate={{
                    x: [0, 5, 0]
                  }} transition={{
                    repeat: Infinity,
                    duration: 1.5,
                    ease: 'easeInOut'
                  }} data-id="element-721">
                      <ArrowRightIcon className="w-5 h-5 text-green-400 group-hover:text-white" data-id="element-722" />
                    </motion.div>
                  </button>
                  <div className="absolute bottom-20 left-0 right-0 flex justify-center" data-id="element-723">
                    <div className="flex space-x-2 bg-black/50 backdrop-blur-sm px-3 py-1 rounded-full" data-id="element-724">
                      {images.map((_, idx) => <div key={idx} className={`w-2 h-2 rounded-full ${idx === currentImage ? 'bg-green-500' : 'bg-gray-500'}`} data-id="element-725" />)}
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.5
      }} viewport={{
        once: true
      }} className="mt-20 md:mt-20 mt-4" data-id="element-726">
          <div className="max-w-7xl mx-auto" data-id="element-727">
            <div className="bg-gradient-to-r from-gray-900/80 via-gray-800/90 to-gray-900/80 p-8 md:p-8 p-4 rounded-xl mb-12 md:mb-12 mb-6 border-b-2 border-green-500 shadow-xl" data-id="element-728">
              <h3 className="text-3xl md:text-3xl text-xl font-bold text-center text-white mb-2" data-id="element-729">
                Fotky před a po (já i táta)
              </h3>
              <div className="w-24 h-1 bg-gradient-to-r from-green-500/50 via-green-500 to-green-500/50 mx-auto rounded-full mb-6 md:mb-6 mb-3" data-id="element-730"></div>
              <p className="text-center text-gray-300 max-w-3xl mx-auto text-base md:text-base text-xs" data-id="element-731">
                Skutečná transformace těla díky kombinaci cvičení a
                superpotravin.
              </p>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-732">
              <TransformationShowcase title="Moje transformace" beforeImage={myTransformationImages[0]} afterImage={myTransformationImages[1]} data-id="element-733" />
              <TransformationShowcase title="Transformace táty" beforeImage={dadTransformationImages[0]} afterImage={dadTransformationImages[1]} imagePosition="center bottom" data-id="element-734" />
            </div>
          </div>
        </motion.div>
      </div>
      <div className="section-divider divider-wave" data-id="element-735"></div>
    </section>;
};